import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Input, Select, Form, Row, Col } from "antd";
import { debounce } from "lodash";
import { getRegions } from "../../../redux/slices/regions/regionsThunk";
import { getSpecialtysList } from "../../../redux/slices/specialtys/specialtysThunk";
import { getGovernments } from "../../../redux/slices/governments/governmentsThunk";

const { Option } = Select;

const FormFields = () => {
  const { specialtysList, governments, regions, loading } = useSelector(
    (state) => ({
      specialtysList: state.specialtys.specialtys,
      governments: state.governments.governments,
      regions: state.regions.regions,
      loading: {
        persons: state.persons.loading,
        specialtys: state.specialtys.loading,
        governments: state.governments.loading,
        regions: state.regions.loading,
      },
    })
  );
  const [search, setSearch] = useState({
    government: "",
    region: "",
    specialty: "",
  });
  const [ids, setIds] = useState({
    government: "",
    region: "",
    specialty: "",
  });

  const dispatch = useDispatch();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceSearch = useCallback(
    debounce((value, key) => {
      setSearch((prevSearch) => ({
        ...prevSearch,
        [key]: value,
      }));
    }, 300),
    [] // Dependencies
  );

  useEffect(() => {
    dispatch(getGovernments({ page: 1, limit: 50, search: search.government }));
  }, [search.government, dispatch]);

  useEffect(() => {
    const selectedGovernmentId = ids.government || null;
    dispatch(
      getRegions({
        page: 1,
        itemsPerPage: 50,
        governmentId: selectedGovernmentId,
        search: search.region || "",
      })
    );
  }, [ids.government, search.region, dispatch]);

  useEffect(() => {
    dispatch(
      getSpecialtysList({
        page: 1,
        itemsPerPage: 50,
        filter: { search: search.specialty },
      })
    );
  }, [search.specialty, dispatch]);

  const handleSearchedValue = (value, key) => {
    debounceSearch(value, key);
  };

  const handleSelect = (key, id) => {
    setIds((prevId) => ({
      ...prevId,
      [key]: id,
    }));
  };

  return (
    <div>
      {loading.persons && <p>Chargement...</p>}

      {[
        { name: "firstname", label: "Nom", placeholder: "Nom" },
        { name: "lastname", label: "Prénom", placeholder: "Prénom" },
        { name: "email", label: "Email", placeholder: "Email" },
        { name: "phoneNumber", label: "Téléphone", placeholder: "Téléphone" },
        { name: "address", label: "Adresse", placeholder: "Adresse" },
      ].map(({ name, label, placeholder }) => (
        <Form.Item
          key={name}
          name={name}
          label={label}
          rules={[
            { required: true, message: `Veuillez entrer ${label.toLowerCase()}` },
          ]}
        >
          <Input placeholder={placeholder} />
        </Form.Item>
      ))}

      <Form.Item label="Coordonnées GPS (Optionnel)">
        <Row gutter={8}>
          <Col span={12}>
            <Form.Item name="latitude" noStyle>
              <Input placeholder="Latitude (ex: 36.8065)" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="longitude" noStyle>
              <Input placeholder="Longitude (ex: 10.1815)" />
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>

      <Form.Item
        name="specialty"
        label="Spécialité"
        rules={[{ required: true, message: "Veuillez sélectionner une spécialité" }]}
      >
        <Select
          placeholder={loading.specialtys ? "Chargement..." : "Choisir une spécialité"}
          loading={loading.specialtys}
          showSearch
          onSearch={(e) => handleSearchedValue(e, "specialty")}
          onSelect={(e) => handleSelect("specialty", e)}
          filterOption={false}
        >
          {specialtysList?.data?.map(({ id, name }) => (
            <Option key={id} value={id}>
              {name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="government"
        label="Gouvernorat"
        rules={[{ required: true, message: "Veuillez sélectionner le gouvernorat" }]}
      >
        <Select
          placeholder={loading.governments ? "Chargement..." : "Choisir un gouvernorat"}
          showSearch
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
          loading={loading.governments}
        >
          {governments?.data?.map(({ id, name }) => (
            <Option key={id} value={id}>
              {name}
            </Option>
          ))}
        </Select>

      </Form.Item>

      <Form.Item
        name="region"
        label="Région"
        rules={[{ required: true, message: "Veuillez sélectionner une région" }]}
      >
        <Select
          placeholder={loading.regions ? "Chargement..." : "Choisir une région"}
          loading={loading.regions}
          showSearch
          onSearch={(e) => handleSearchedValue(e, "region")}
          onSelect={(e) => handleSelect("region", e)}
          filterOption={false}
        >
          {regions?.data?.map(({ id, name }) => (
            <Option key={id} value={id}>
              {name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="doctorType"
        label="Type"
        rules={[{ required: true, message: "Veuillez sélectionner un type" }]}
      >
        <Select placeholder="Choisir un type">
          <Option value={1}>Privé</Option>
          <Option value={2}>Hospitalier</Option>
        </Select>
      </Form.Item>
    </div>
  );
};

export default FormFields;
